import { HeaderService } from './../../../_services/header.service';
import { Component, ElementRef, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { HeaderModel } from "src/app/_component/header/header.model";
import { customValidators } from "src/app/_helpers/customValidators";
import { globalHelper } from "src/app/_helpers/global";
import { UserService } from "src/app/_services";
import { ThisPlatform } from "src/app/_services/platform.service";
import { PaginationClientSideOptions } from "../../_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "../../_component/pagination-client-side/pagination-column.class";
import { RowsLoaderService } from "../../../_services/rows-loader.service";
import { BuildingFloorViewComponent } from "../building-floor-view/building-floor-view.component";
import { Building } from "../building.model";
import { BuildingService } from "../building.service";
import { EditFloorPage } from "../edit-floor/edit-floor.page";
import { Floor } from "../floor/floor.model";
import { FloorService } from "../floor/floor.service";
import { MaskitoOptions } from '@maskito/core';

@Component({
  selector: "app-edit-building",
  templateUrl: "./edit-building.page.html",
  styleUrls: [
    "./edit-building.page.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class EditBuildingPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public buildingServ: BuildingService,
    public alertController: AlertController,
    public floorServ: FloorService,
    private translateService: TranslateService,
    public userServ: UserService,
    public loadingCtrl: LoadingController,
    public p: ThisPlatform,
    private modalCtrl: ModalController,
    private el: ElementRef,
    private headerServ: HeaderService
  ) {}

  disableSaveButton: boolean = false;

  floorsColumns: PaginationColumn[] = [
    {
      name: "level",
      displayName: "LEVEL",
      size: 3,
      sortable: true,
    },
    {
      name: "name",
      displayName: "NAME",
      size: 3,
      sortable: true,
    },
    {
      name: "description",
      displayName: this.translateService.instant("DESCRIPTION"),
      size: 4,
      sortable: true,
    },
  ];

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    overrideCountTranslation: "BUILDING.FLOORS_",
    mobileViewBreakPoint: 1360,
    mainStyle: "gray-md-rows",
    permissionEdit: true,
    permissionSpaceAdd: true,
    headerEmitClick: true,
    headerAddRemoveColSize: 2,
  };

  componentRef: any = BuildingFloorViewComponent;
  floorsRowsLoader: RowsLoaderService;

  fileData: File = null;
  previewUrl: any = null;
  building: Building;
  buildingId: number;
  validationError: boolean = false;

  isError: boolean = false;
  errorStatus: number;
  deleteAttachments = false;
  form: FormGroup;

  zipPattern: RegExp = new RegExp("[0-9]{2}-[0-9]{3}");

  headerInit: HeaderModel = {
    title: "",
    backDefaultHref: "/app/building",
    showRightButtonsOnlyOnMobile: true,
    rightButtons: []
  };

  loading: boolean = true;

  readonly postCodeMaskOptions: MaskitoOptions = {
    mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/],
  }

  async ngOnInit() {
    this.initForm();
    this.deleteAttachments = false;

    this.options.permissionEdit = await this.userServ.hasRolesAsync([
      "building.floor.edit",
    ]);

    this.building = new Building();
    this.floorServ.floors = null;

    this.route.paramMap.subscribe((paramMap) => {
      if (paramMap.has("BuildingId")) {
        this.loading = true;
        this.headerInit.title = this.translateService.instant("EDIT_BUILDING");
        this.headerInit.rightButtons = [
          {
            iconName: "trash",
            rolePermission: ["building.edit"],
            onClick: () => this.deleteBuilding(),
          },
        ];

        this.buildingId = Number(paramMap.get("BuildingId"));

        this.RefreshFloors();

        this.buildingServ.getBuilding(this.buildingId).subscribe({
          next: (building: Building) => {
            this.building = building;
            this.loadBuildingDetails();
          },
          error: (err) => {
            this.isError = true;
            this.errorStatus = err.status;
          }}
        );
      } else {
        this.loading = false;
        this.headerInit.title = this.translateService.instant(
          "BUILDING.NEW_BUILDING"
        );
      }
    });

    this.options.permissionEdit = await this.userServ.hasRolesAsync([
      "building.floor.edit",
    ]);

    this.options.permissionSpaceAdd = await this.userServ.hasRolesAsync([
      "building.floor.edit",
    ]);
  }
  
  ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl("", {
        updateOn: "blur",
        validators: [
          Validators.required,
          Validators.maxLength(30),
          customValidators.trimValidator(),
        ],
      }),
      description: new FormControl("", {
        updateOn: "blur",
        validators: [Validators.maxLength(250)],
      }),
      street: new FormControl("", {
        updateOn: "blur",
        validators: [Validators.maxLength(100)],
      }),
      city: new FormControl("", {
        updateOn: "blur",
        validators: [Validators.maxLength(30)],
      }),
      postCode: new FormControl("", {
        updateOn: "blur",
        validators: [customValidators.zipCodePattern],
      }),
      itemImage: new FormControl("", {
        updateOn: "blur",
        validators: [
          customValidators.fileMaxSize(10000000),
          customValidators.fileFormat([
            "jpg",
            "png",
            "gif",
            "jfif",
            "pjpeg",
            "jpeg",
            "pjp",
          ]),
        ],
      }),
    });
  }

  loadBuildingDetails() {
    this.form.patchValue({
      name: this.building.name,
      description: this.building.description,
      street: this.building.street,
      city: this.building.city,
      postCode: this.building.postCode,
      itemImage: this.building.image,
    });
    this.loading = false;
  }

  backToBuildingList() {
    this.router.navigate(["/app/building"]);
  }

  floorsRowsLoaderServiceReady(loader: RowsLoaderService) {
    this.floorsRowsLoader = loader;
    this.floorsRowsLoaderInit()
  }

  floorsRowsLoaderInit() {
    if (this.floorsRowsLoader) {
      this.floorsRowsLoader.init(this.floorServ.floors);
    }
  }

  RefreshFloors() {
    this.floorServ.getFloors(this.buildingId).subscribe((floor: Floor[]) => {
      this.floorServ.floors = floor;
      this.floorsRowsLoaderInit();
    });
  }

  async deleteBuilding() {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService
    );

    if (confirm) {
      this.loadingCtrl
        .create({
          keyboardClose: true,
          message: this.translateService.instant("DELETING"),
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.buildingServ.deleteBuilding(this.buildingId).subscribe((res) => {
            loadingEl.dismiss();
            this.router.navigate(["/app/building"]);
          });
        });
    }
  }

  imageUploaded(file: File) {
    this.deleteAttachments = false;
    this.fileData = file;
  }

  imageRemoved($event) {
    this.deleteAttachments = true;
    this.fileData = null;
  }

  onSaveBuilding() {
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }
    this.saveBuilding(this.form.value);
  }

  saveBuilding(form) {
    this.disableSaveButton = true;
    const formData = new FormData();

    formData.append("name", form.name ? form.name : "");
    formData.append("description", form.description ? form.description : "");
    formData.append("street", form.street ? form.street : "");
    formData.append("city", form.city ? form.city : "");
    formData.append("postCode", form.postCode ? form.postCode : "");
    this.fileData ? formData.append("file", this.fileData) : "";

    if (this.deleteAttachments) {
      formData.append("deleteAttachments", JSON.stringify(true));
    }

    if (this.buildingId) {
      this.buildingServ
        .updateBuilding(this.buildingId, formData)
        .subscribe((res) => {
          this.disableSaveButton = false;
          this.router.navigateByUrl("/app/building");
        });
    } else {
      this.buildingServ.createBuilding(formData).subscribe((res) => {
        this.disableSaveButton = false;
        this.router.navigateByUrl("/app/building");
      });
    }
  }

  handleActionRequest(action) {
    if (action.type == "remove") {
      this.deleteFloor(action.id);
    }
    if (action.type == "edit") {
      this.editFloorModal(action.id);
    }
  }

  async deleteFloor(floorId: string) {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService
    );
    if (confirm) {
      this.loadingCtrl
        .create({
          keyboardClose: true,
          message: this.translateService.instant("DELETING"),
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.floorServ.deleteFloor(Number(floorId)).subscribe((res) => {
            loadingEl.dismiss();
            this.RefreshFloors();
          });
        });
    }
  }

  addFloor() {
    this.editFloorModal();
  }

  async editFloorModal(floorId?: number) {
    const modal = await this.modalCtrl.create({
      component: EditFloorPage,
      animated: true,
      cssClass: "add-edit-modal add-edit-modal--edit-parking-space",
      componentProps: {
        buildingId: this.buildingId,
        floorId: floorId,
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role !== "backdrop") {
        this.RefreshFloors();
      }
    });
    modal.present();
  }

  ionViewDidLeave() {
    this.building = null;
    this.form.reset();
  }

  onSelectTouched(formControlName: string): void {
    this.form.get(formControlName).markAsTouched();
  }

  checkReadonly() {
    return !this.userServ.hasRoles([
      "building.edit",
    ]);
  }
}
